/* eslint-disable */
/* eslint-disable no-restricted-syntax */
import Blockly from 'blockly';
import { debounce } from 'debounce-decorator';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import _ from 'lodash';
import classRoomStore from 'store/classRoomStore';

// import { full } from 'acorn/dist/walk';

import { statehookify } from './hookFactory';

const { convertJavaScript2XML } = require('libraries/BlocklyJavaScript2XML');

function genBlocklyUid(...rest) {
  return Blockly.utils.genUid(...rest);
}

function extractAllArgs(def) {
  return Object.entries(def).reduce((acc, [defKey, value]) => {
    if (defKey.startsWith('args')) {
      acc[parseInt(defKey.slice('args'.length), 10)] = value;
    }
    return acc;
  }, []);
}

function extractAllArgItems(def) {
  return extractAllArgs(def).reduce((acc, curr) => {
    return acc.concat(curr);
  }, []);
}
function convertAcornRange2MonacoRange(sourceCode, acornRange) {
  // acornRange = { start, end }
  const { start, end } = acornRange;
  const beforeStart = '\n' + sourceCode.substr(0, start);
  const beforeEnd = '\n' + sourceCode.substr(0, end);
  return {
    startLineNumber: beforeStart.match(/\n/g).length,
    startColumn: beforeStart.length - beforeStart.lastIndexOf('\n'),

    endLineNumber: beforeEnd.match(/\n/g).length,
    endColumn: beforeEnd.length - beforeEnd.lastIndexOf('\n'),
  };
}

function convertMonacoRange2AcornRange(argSourceCode, monacoRange) {
  const {
    startLineNumber,
    startColumn,
    endLineNumber,
    endColumn,
  } = monacoRange;
  const sourceCode = `\n${argSourceCode}`; // the first line is 1 in the editor
  // const template = `
  // 0:
  // 1:log('hello');
  // 2:log('world');
  // 3:
  // `;
  let loopTimesStart = startLineNumber;
  let startLineIndex = -1;
  while (loopTimesStart > 0) {
    startLineIndex = sourceCode.indexOf('\n', startLineIndex + 1);
    loopTimesStart -= 1;
  }
  let loopTimesEnd = endLineNumber;
  let endLineIndex = -1;
  while (loopTimesEnd > 0) {
    endLineIndex = sourceCode.indexOf('\n', endLineIndex + 1);
    loopTimesEnd -= 1;
  }
  const start = startLineIndex + startColumn;
  const end = endLineIndex + endColumn;

  return {
    start,
    end,
  };
}
export { convertAcornRange2MonacoRange };
export { convertMonacoRange2AcornRange };
export { extractAllArgItems };
export const codeBlocklyStatehook = statehookify('codeBlocklyStatehook', {
  addFunctionFromJsonInit(blocklyType, definition) {
    definition = Object.assign({}, definition);
    Object.keys(definition).forEach((itemKey) => {
      if (itemKey.startsWith('args')) {
        definition[itemKey] = Array.from(definition[itemKey]).filter((arg) => {
          if (arg.type === 'field_image') return false;
          if (arg.type === 'field_label') return false;
          return true;
        });
      }
    });
    return this.setHookStatePath(['blocks', blocklyType], definition);
  },
  get allBlockDefinitions() {
    return this.getHookStatePath(['blocks']);
  },
  findBlockDefinition(blocklyType) {
    return this.getHookStatePath(['blocks', blocklyType]);
  },
  getJSAllFunctionDefinitionsForMonaco(opt, additions) {
    additions = additions || [];
    const blocks = this.allBlockDefinitions || {};
    // {
    //   label: '"lodash"',
    //   kind: monaco.languages.CompletionItemKind.Function,
    //   documentation: "The Lodash library exported as Node.js modules.",
    //   insertText: '"lodash": "*"',
    //   range: range
    // },
    return Object.entries(blocks).reduce((acc, [blockType, def]) => {
      const args = extractAllArgItems(def).reduce((accArg, row) => {
        if (row.name) {
          if (row.name === 'CALLBACK' && row.type === 'input_statement') {
            // a callback function
            accArg.push(`() => {\n\t\${${accArg.length + 1}:// Your logic here!}\n}`);
          } else {
            accArg.push(`\${${accArg.length + 1}:${row.name}__${row.type}}`)
          }
        }
        return accArg;
      }, []);
      // def.forEach((rowDef) => {
      //   Object.entries(rowDef).forEach(([currDefKey, currVal]) => {
      //     if (currDefKey.startsWith('args')) {
      //       currVal = _.get(currVal, '[0]') || currVal;
      //       args[currDefKey.slice('args'.length)] = `${currVal.name}__${currVal.type}`;
      //     }
      //   });
      // });
      acc.push(Object.assign({
        label: blockType,
        kind: monaco.languages.CompletionItemKind.Function,
        // https://microsoft.github.io/monaco-editor/api/interfaces/monaco.languages.completionitem.html#documentation
        documentation: def.message0,
        detail: def.message0,
        insertText: `${blockType}(${args.join(', ')})`,
        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
      }, opt));
      return acc;
    }, []).concat(additions.map((row) => {
      return Object.assign({
        kind: monaco.languages.CompletionItemKind.Function,
        // https://microsoft.github.io/monaco-editor/api/interfaces/monaco.languages.completionitem.html#documentation
        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
      }, row, opt);
    }));
  },
  convertAcornRange2MonacoRange(acornRange) {
    return convertAcornRange2MonacoRange(this.codeJavaScript, acornRange);
  },
  convertMonacoRange2AcornRange(range) {
    return convertMonacoRange2AcornRange(this.codeJavaScript, range);
  },
  set codeJavaScript(newValue) {
    this.setHookStatePath('codeJavaScript', newValue);
    this.buildJavaScriptASTDebounce(newValue, (error, instance) => {
      this.instanceOfJavaScriptAST2XML = instance;
      if (instance) {
        classRoomStore.setXML(instance.getXML());
      }
    });
  },
  get codeJavaScript() {
    return this.getHookStatePath('codeJavaScript');
  },
  buildJavaScriptASTDebounce: debounce(function (code, cb) {
    const result = this.buildJavaScriptAST(code);
    cb(...result);
  }, 0.5 * 1e3),
  buildJavaScriptAST(code) {
    const result = convertJavaScript2XML(code, this.allBlockDefinitions);
    const [error, instance] = result;
    const errorsOfJavaScript = Array.from(_.get(instance, 'errors') || []);
    if (error) {
      console.error(error);
      // check unexpected token error
      const matched = /.* \((\d+):(\d+)\)/g.exec(_.get(error, 'message') || `${error}`);
      if (matched) {
        // const originalMessage = matched[0];
        const lineNumber = parseInt(matched[1]);
        const columnNumber = parseInt(matched[2]);
        
        errorsOfJavaScript.push({
          error,
          section: this.convertMonacoRange2AcornRange({
            startLineNumber: lineNumber,
            startColumn: columnNumber,
            endLineNumber: lineNumber,
            endColumn: columnNumber + 1,
          }),
        })
      } else {
        kaiAlert.popupError(error);
      }
    }
    this.errorsOfJavaScript = errorsOfJavaScript;
    return result;
  },
  set errorsOfJavaScript(newValue) {
    this.setHookStatePath('errorsOfJavaScript', newValue);
  },
  get errorsOfJavaScript() {
    return this.getHookStatePath('errorsOfJavaScript') || [];
  },
  watchErrorsOfJavaScript(cb) {
    return this.watchHookStatePath('errorsOfJavaScript', cb);
  },
  set instanceOfJavaScriptAST2XML(instance) {
    this.setHookStatePath('instanceOfJavaScriptAST2XML', instance);
  },
  get instanceOfJavaScriptAST2XML() {
    return this.getHookStatePath('instanceOfJavaScriptAST2XML');
  },
  watchInstanceOfJavaScriptAST2XML(cb) {
    return this.watchHookStatePath('instanceOfJavaScriptAST2XML', cb)
  },
  watchCodeJavaScript(cb) {
    return this.watchHookStatePath('codeJavaScript', cb);
  },

  findErrorsByASTRange(range) {
    const { start, end } = range;
    return this.errorsOfJavaScript.filter((err) => {
      const s1 = err.section.start;
      const e1 = err.section.end;
      const s2 = start;
      const e2 = end;

      // s1[  s2[  e2]  e1]
      if (s1 <= s2 && e2 <= e1) return true;
      // s2[  s1[  e1]  e2]
      if (s2 <= s1 && e1 <= e2) return true;
      // s1[   e1]   s1[    e1]
      //   s2[         e2]
      if (s1 <= s2 && e1 >= s2) return true;
      if (s1 <= e2 && e1 >= e2) return true;
      return false;
    });
  },
}, {});
